export default {
    namespaced: true,
    state() {
        return {
            requester: window?.data?.order?.requester ?? undefined,
            organisations: [],
            organisation: undefined,
            project: undefined,
            firstName: undefined,
            lastName: undefined,
        }
    },
    getters: {
        completed(state) {
            return !!state.firstName && !!state.lastName && (!state.organisation || !!state.project);
        },
        form(state) {
            return {
                id: state.requester ? state.requester.id : undefined,
                firstname: state.firstName,
                lastname: state.lastName,
                organisation_id: state.organisation ? state.organisation.id : undefined,
                project: state.project,
            };
        },
    },
    actions: {
        loadOrganisations({commit}) {
            api.organisation.index().then(
                response => commit('setOrganisations', response.data.data)
            )
        },
    },
    mutations: {
        setOrganisations(state, organisations) {
            state.organisations = organisations;
        },
        setOrganisation(state, organisation) {
            state.organisation = organisation;
        },
        setProject(state, project) {
            state.project = project;
        },
        setFirstName(state, firstName) {
            state.firstName = firstName;
        },
        setLastName(state, lastName) {
            state.lastName = lastName;
        },
    },
}
